import { getStyledWrapper } from "@insite/client-framework/Common/StyledWrapper";
import siteMessage from "@insite/client-framework/SiteMessage";
import { OrderStateContext } from "@insite/client-framework/Store/Data/Orders/OrdersSelectors";
import translate from "@insite/client-framework/Translate";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import Icon, { IconPresentationProps } from "@insite/mobius/Icon/Icon";
import Typography, { TypographyProps } from "@insite/mobius/Typography";
import getColor from "@insite/mobius/utilities/getColor";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import { TYPOGRAPHY } from "@tKgpco/theme/design";
import * as React from "react";
import { useContext } from "react";
import { css } from "styled-components";

export interface OrderDetailsFailureMSGStyles {
    titleText: TypographyProps;
    warningIcon?: IconPresentationProps;
    warningSection?: InjectableCss;
    warningText?: InjectableCss;
}

export const titleStyles: OrderDetailsFailureMSGStyles = {
    titleText: {
        variant: "h2",
        as: "h1",
    },
    warningIcon: {
        src: "AlertCircle",
        color: "danger.main",
        css: css`
            margin-right: 10px;
        `,
    },
    warningSection: {
        css: css`
            display: flex;
            align-items: flex-start;
            border: 2px solid ${getColor("danger.main")};
            padding: 10px 10px;
            margin-bottom: 5px;
            background-color: #fff3cd; /* Light yellow background */
            color: #856404; /* Dark text for contrast */
            font-weight: bold;
            padding: 12px;
            border: 1px solid #ffeeba; /* Subtle border */
            border-radius: 5px;
            display: flex;
            align-items: center;
            font-size: 16px;

            .errorList {
                list-style-type: disc;
                margin-left: 1rem;
                li {
                    color: ${getColor("danger.main")};
                }
            }
        `,
    },
    warningText: {
        css: css`
            font-size: 15px;
            color: ${getColor("danger.main")};
            font-weight: ${TYPOGRAPHY.weight.bold};
        `,
    },
};

const styles = titleStyles;

const StyledSection = getStyledWrapper("section");

const OrderDetailsFailureMSG: React.FC = () => {
    const { value: order } = useContext(OrderStateContext);

    if (!order?.erpOrderNumber && order?.webOrderNumber) {
        return (
            <StyledSection {...styles.warningSection}>
                <Icon {...styles.warningIcon}></Icon>
                <Typography {...styles.warningText}>{siteMessage("Order_Submission_failure")}</Typography>
            </StyledSection>
        );
    }

    return null;
};

const widgetModule: WidgetModule = {
    component: OrderDetailsFailureMSG,
    definition: {
        allowedContexts: ["OrderDetailsPage", "VmiOrderDetailsPage"],
        group: "Order Details",
    },
};

export default widgetModule;
